import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm font-label text-foreground-500">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <li className="flex items-center gap-2">
          <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-300" aria-hidden="true"></i>
            {item.href && index < items.length - 1 ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}